import { useContext } from 'react'
import { IconContainerOptionsContext } from './IconContainerOptionsProvider.tsx'

export const useIconContainerOptionsContext = () => {
  return useContext(IconContainerOptionsContext)
}
